module.exports = __webpack_public_path__ + "static/ceo1-f0320469c533ee55b341130516517460.jpg";